// @file Entrypoint for home page
import Vue, { CreateElement, VNode } from 'vue'
import IntlPlugin from 'vueplugins/intl_plugin'
import HomeApp from 'vuecomponents/home_app.vue'
import store from 'vuexstore/home_store'
import 'styles/tailwind.css'

Vue.use(IntlPlugin)

document.addEventListener('DOMContentLoaded', (): void => {
  const _ = new Vue({
    el: '#app',
    store,
    render: (h: CreateElement): VNode => h(HomeApp),
  })
})
